module.exports = __webpack_public_path__ + "static/media/GiantLanternINTST01A0014_design_clean_v002.3775b7db.png";